export const ru = {
  header: {
    title: 'Доктор Путкарадзе',
  },
  nav: {
    about: 'О нас',
    gallery: 'Галерея',
    services: 'Услуги',
    education: 'Образовательные ресурсы',
    news: 'Новости',
    askDoctor: 'Спросить Доктора',
    contact: 'Контакты'
  },
  gallery: {
    title: 'Галерея',
    subtitle: 'Фотографии из нашей медицинской практики',
  },
  news: {
    title: 'Новости',
    subtitle: 'Последние обновления и статьи от доктора Путкарадзе',
    readMore: 'Подробнее',
    backToNews: 'Назад к новостям',
    publishedOn: 'Опубликовано',
    noPosts: 'Новостей пока нет.',
    admin: {
      title: 'Управление новостями',
      subtitle: 'Создавайте и управляйте новостями',
      totalPosts: 'Всего постов',
      published: 'Опубликовано',
      drafts: 'Черновики',
      createPost: 'Создать пост',
      editPost: 'Редактировать пост',
      deletePost: 'Удалить пост',
      deleteConfirm: 'Вы уверены, что хотите удалить этот пост?',
      form: {
        titleEn: 'Заголовок (Английский)',
        titleKa: 'Заголовок (Грузинский)',
        titleRu: 'Заголовок (Русский)',
        contentEn: 'Контент (Английский)',
        contentKa: 'Контент (Грузинский)',
        contentRu: 'Контент (Русский)',
        image: 'Главное изображение',
        uploadImage: 'Загрузить изображение',
        changeImage: 'Изменить изображение',
        removeImage: 'Удалить изображение',
        publish: 'Опубликовать',
        saveDraft: 'Сохранить как черновик',
        cancel: 'Отмена',
        save: 'Сохранить',
        publishing: 'Публикация...',
        saving: 'Сохранение...'
      }
    }
  },
  education: {
    title: 'Образовательные ресурсы',
    subtitle: 'Подборка материалов для лучшего понимания травматологии и ортопедии',
    georgian: {
      title: 'Образовательные ресурсы на грузинском языке',
      watchVideo: 'Смотреть видео'
    },
    english: {
      title: 'Образовательные ресурсы на английском языке',
      watchVideo: 'Смотреть видео'
    },
    russian: {
      title: 'Образовательные ресурсы на русском языке',
      watchVideo: 'Смотреть видео'
    }
  },
  hero: {
    title: 'Доктор Гиорги Путкарадзе',
    subtitle: 'Признанный специалист в области травматологии и ортопедии',
    cta: 'Записаться на прием',
  },
  about: {
    sectionTitle: 'Медицинский опыт',
    certifiedSpecialist: 'Сертифицированный специалист',
    aoMethodology: 'Методология AO',
    internationalStandards: 'Международные стандарты',
  },
  stats: {
    childbirths: {
      number: '5,000+',
      text: 'Успешных операций',
    },
    complications: {
      number: '2,500+',
      text: 'Замен суставов',
    },
    surgeries: {
      number: '1,000+',
      text: 'Сложных реимплантаций',
    },
    experience: {
      number: '10+',
      text: 'Лет опыта',
    },
  },
  expertise: {
    title: 'Экспертиза и специализации',
    subtitle: 'С многолетним опытом в травматологии и ортопедии, доктор Гиорги Путкарадзе успешно пролечил тысячи пациентов как консервативно, так и сложными хирургическими вмешательствами.',
    services: {
      obstetrics: {
        title: 'Травматологические услуги',
        description: 'Диагностика и лечение по методическим рекомендациям AO: переломы костей, вывихи, растяжения, повреждения связок и сухожилий — как бытовые, так и спортивные травмы.',
      },
      surgery: {
        title: 'Ортопедические услуги',
        description: 'Артроз, артрит, боль в суставах, ограничение подвижности, оценка и лечение воспалительных и дегенеративных процессов, эндопротезирование всех крупных суставов.',
      },
      health: {
        title: 'Ведение сложных случаев',
        description: 'Реконструктивная хирургия с использованием ревизионной реимплантации.',
      },
      additional: {
        title: 'Консервативное лечение',
        description: 'Иммобилизация, инъекционная терапия, правильное планирование физических нагрузок, индивидуальные программы реабилитации и восстановления.',
      },
    },
  },
  contact: {
    title: 'Контактная информация',
    subtitle: 'Запишитесь на прием или свяжитесь с нами по любым вопросам.',
    getInTouch: 'Свяжитесь с нами',
    mobile: 'Мобильный',
    office: 'Офис',
    currentWorkplaces: 'Текущие места работы',
    phone: '+995 596 09 10 00',
    landline: '',
    email: 'futkaradzegiorgi@gmail.com',
    clinics: {
      openHeart: 'Батумский Медицинский Центр (Батуми)',
      barbara: 'Нуралидзе Уникмед (Кутаиси)'
    },
    hours: 'Понедельник - Пятница: 9:00 - 18:00',
    appointments: 'Доступна запись на прием',
  },
  footer: {
    copyright: '© {year} Доктор Гиорги Путкарадзе. Все права защищены.',
  },
  aiChat: {
    title: 'AI Медицинский Ассистент',
    backToHome: 'Вернуться на главную',
    description: 'Этот AI ассистент поможет вам с:',
    capabilities: {
      general: 'Общая медицинская информация и рекомендации',
      symptoms: 'Распространенные симптомы и состояния',
      recommendations: 'Базовые рекомендации по здоровью',
      pregnancy: 'Информация о травматологии и ортопедии'
    },
    disclaimer: 'Обратите внимание: AI предоставляет только общую информацию и не заменяет профессиональную медицинскую консультацию.',
    askDoctor: {
      title: 'Задать вопрос доктору Путкарадзе',
      description: 'Есть конкретный вопрос для доктора Путкарадзе? Оставьте свой вопрос здесь, и доктор лично рассмотрит и ответит на ваш запрос в рабочее время. Вы также можете прикрепить соответствующие медицинские документы, чтобы помочь доктору лучше понять вашу ситуацию.',
      instructions: {
        title: 'Как задать вопрос',
        steps: 'Укажите вашу контактную информацию\nНапишите ваш медицинский вопрос подробно\nПрикрепите соответствующие медицинские документы (необязательно)\nОтправьте вопрос и ждите ответа по электронной почте'
      },
      attachments: {
        title: 'Сопроводительные документы',
        description: 'Вы можете прикрепить соответствующие медицинские документы:',
        voice: {
          title: 'Голосовая запись',
          description: 'Вы можете записать свой голос, чтобы подробно объяснить свой вопрос',
          start: 'Начать запись',
          stop: 'Остановить запись',
          delete: 'Удалить запись',
          duration: 'Продолжительность записи: {seconds} секунд',
          instructions: 'Нажмите, чтобы начать запись голосового сообщения. Говорите четко и подробно опишите вашу медицинскую проблему.'
        },
        types: 'Результаты лабораторных анализов\nЗаключения по медицинским снимкам\nПредыдущие медицинские записи\nДокументы рецептов',
        limits: 'Принимаемые форматы: Изображения, PDF, DOC. Максимальный размер: 10МБ на файл',
        button: 'Добавить документы',
        remove: 'Удалить'
      },
      emailNote: 'Вы получите ответ по электронной почте',
      namePlaceholder: 'Ваше имя',
      emailPlaceholder: 'Ваш email',
      phonePlaceholder: 'Телефон (необязательно)',
      label: 'Ваш вопрос',
      placeholder: 'Введите ваш медицинский вопрос здесь...',
      submit: 'Отправить вопрос',
      error: 'При отправке вопроса произошла ошибка. Пожалуйста, попробуйте еще раз.',
      success: {
        title: 'Спасибо за ваш вопрос!',
        message: 'Доктор Путкарадзе рассмотрит и ответит на ваш запрос по электронной почте как можно скорее.',
        askAnother: 'Задать другой вопрос'
      }
    }
  },
  askDoctor: {
    form: {
      namePlaceholder: 'Ваше имя',
      emailPlaceholder: 'Ваш email'
    }
  },
  chat: {
    title: 'AI Медицинский Ассистент',
    subtitle: 'Получите экспертные медицинские консультации 24/7',
    disk: {
      medicalAssistance: 'Медицинская Помощь',
      healthGuidance: 'Советы по Здоровью',
      expertSupport: 'Поддержка Эксперта',
      available: 'Доступно 24/7'
    },
    welcome: 'Задайте любые медицинские вопросы, основанные на опыте доктора Путкарадзе',
    placeholder: 'Введите ваш вопрос здесь...',
    error: 'Извините, но возникли проблемы с подключением. Пожалуйста, попробуйте еще раз.',
    online: 'Онлайн',
    typing: 'Печатает...',
    thinking: 'Думает...',
    inputAriaLabel: 'Ввод сообщения',
    sendAriaLabel: 'Отправить сообщение',
    quickReplies: {
      appointments: 'Как записаться на прием?',
      services: 'Какие услуги вы предоставляете?',
      location: 'Где находится ваша клиника?'
    }
  },
  admin: {
    portal: 'Панель администратора',
    login: 'Вход администратора',
    signIn: 'Войти',
    signingIn: 'Вход...',
    email: 'Электронная почта',
    password: 'Пароль',
    backToHome: 'Вернуться на главную',
    signInSubtitle: 'Войдите для доступа к панели администратора',
    authError: 'Ошибка аутентификации',
    accessInfo: 'Доступ в эту область имеет только авторизованный персонал. Пожалуйста, свяжитесь с системным администратором, если вам нужен доступ.'
  },
  chatHistory: {
    backToChat: 'Вернуться к чату',
    title: 'История чата',
    noConversations: 'Предыдущие разговоры не найдены.',
    view: 'Просмотр',
    delete: 'Удалить',
    deleteConfirmation: 'Вы уверены, что хотите удалить этот разговор? Это действие нельзя отменить.'
  },
  response: {
    respondToPatient: 'Ответить пациенту',
    patientQuestion: 'Вопрос пациента:',
    aiResponse: 'AI-сгенерированный ответ:',
    placeholder: 'Отредактируйте или напишите свой ответ здесь...',
    downloadPdf: 'Скачать PDF',
    cancel: 'Отмена',
    send: 'Отправить'
  },
  email: {
    title: 'Медицинский ответ - Доктор Путкарадзе',
    header: 'Медицинская платформа доктора Путкарадзе',
    subheader: 'Профессиональный ответ на медицинскую консультацию',
    patientInfo: 'Информация о пациенте',
    yourQuestion: 'Ваш вопрос',
    medicalResponse: 'Медицинский ответ',
    footer: 'Профессиональные консультационные услуги в области здравоохранения',
    generated: 'Сгенерировано'
  },
  locations: {
    tbilisiGeorgia: 'Тбилиси, Грузия'
  },
  adminGuidelines: {
    title: 'Как ответить',
    subtitle: 'Следуйте этим шагам при ответе на вопросы пациентов',
    steps: {
      step1: 'Прочитайте вопрос и вложения',
      step2: 'Используйте ИИ ассистента при необходимости',
      step3: 'Нажмите "Ответить" чтобы открыть форму',
      step4: 'Напишите или отредактируйте ответ',
      step5: 'Нажмите "Отправить" для отправки пациенту'
    },
    collapse: 'Скрыть',
    expand: 'Показать'
  }
};